export default function BlogHero({ title, subtitle, image }) {
	return (
		<section className="relative bg-gray-50 mt-12">
			<div className="max-w-4xl mx-auto text-center px-6 py-16">
				<h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
					{title}
				</h1>
				{subtitle && <p className="mt-4 text-lg text-gray-600">{subtitle}</p>}
			</div>
			{image && (
				<img src={image} alt={title} className="w-full h-96 object-cover" />
			)}
		</section>
	);
}
